import React, { Component } from "react";
import { func, bool } from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { compose } from "redux";

import { selectors as sessionSelectors } from "reducers/session";
import { selectors as depositsSelectors, actions as depositsActions } from "reducers/deposits";

import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import Col from "react-bootstrap/lib/Col";
import Credential from "pages/_components/fields/credentials/Credential";
import Yup from "yup";
import Button from "pages/_components/Button";
import Notification from "pages/_components/Notification";
import { Field, Form, withFormik } from "formik";

import MainContainer from "pages/_components/MainContainer";
import Container from "pages/_components/Container";

import DepositSummaryData from "pages/deposits/_components/DepositSummaryData";
import { resizableRoute } from "pages/_components/Resizable";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";

import { getAccountDescription } from "util/accounts";
import * as i18nUtils from "util/i18n";
import * as configUtil from "util/config";
import isTokenActive from "util/token";

const FORM_ID = "deposits.summary";

class DepositSummary extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        loadingConfirm: bool.isRequired,
        isDesktop: bool.isRequired,
        isSubmitting: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    getAccountDescription({ number, productType, currency }) {
        const { dispatch } = this.props;
        if (!number) {
            dispatch(push("/deposits"));
            return "";
        }
        return getAccountDescription({ number, productType, currency });
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        const timeExtended = configUtil.getBoolean("frontend.PlazoFijo.timeExtended", false);
        const goBackPath = timeExtended ? "/v2/depositsConstitute" : "/depositsConstitute";
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["depositsSummary"],
            titleKey: "deposits.summary.label",
            goBackPath,
        });
    };

    handleBack = () => {
        const { dispatch } = this.props;
        const timeExtended = configUtil.getBoolean("frontend.PlazoFijo.timeExtended", false);
        const route = timeExtended ? "/v2/depositsConstitute" : "/depositsConstitute";
        dispatch(push(route));
    };

    centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1 style={{ margin: "-0.5rem 2rem" }}>{i18nUtils.get("deposits.summary.label")}</h1>
        </div>
    );

    render() {
        const { isDesktop, loadingConfirm, isSubmitting, embeddedInV3Shell } = this.props;

        const continueButton = (
            <Col className="col-12" lg={12} md={12} sm={12}>
                <Button
                    type="submit"
                    bsStyle="primary"
                    label="global.confirm"
                    image="images/arrowRight.svg"
                    imageStyle="mr-2"
                    className="text-capitalize"
                    loading={loadingConfirm || isSubmitting}
                />
            </Col>
        );

        const credentials = (
            <>
                {!isTokenActive(!isDesktop) ? (
                    <div className="admin-content-center deposit-summary">
                        <I18n id="deposits.summary.confirm.label" />
                    </div>
                ) : (
                    <div className="admin-content-center pb-3">
                        <I18n
                            id="confirmation.withoutotp.text"
                            component="p"
                            componentProps={{ className: "confirmation__text-without-otp" }}
                        />
                    </div>
                )}
                <div className="admin-content-center">
                    <Field
                        placeholderText={i18nUtils.get(`confirmation.otp.placeholder`)}
                        name="otp"
                        type="otp"
                        idForm={FORM_ID}
                        component={Credential}
                    />
                </div>
            </>
        );

        const checkInfoTitle = (
            <div
                className="admin-content-center"
                style={{ marginBottom: isDesktop ? "2rem" : "1rem" }}>
                <I18n id="deposits.summary.checkInfo.label" component="h2" />
            </div>
        );

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="depositsSummary" />}
                {!(embeddedInV3Shell && !isDesktop) && (
                    <div className="admin-detail-head px-0">
                        <Head
                            onBack={this.handleBack}
                            onClose={this.handleBack}
                            headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                            centerElement={isDesktop ? undefined : this.centerContentMobile}
                            closeImageWhite={!isDesktop}
                        />
                        {isDesktop && <h1>{i18nUtils.get("deposits.summary.label")}</h1>}
                    </div>
                )}
                <MainContainer viewContentStyle={!isDesktop ? { overflowX: "hidden" } : undefined}>
                    <Form className="above-the-fold">
                        <Container
                            className={`flex-grow align-items-center container-white with-margin${
                                !isDesktop ? " mb-0" : ""
                            }`}
                            gridClassName="form-content"
                            rowClassName={
                                !isDesktop ? "justify-content-center mx-0" : "justify-content-center"
                            }>
                            {isDesktop ? (
                                <div className="admin-content-center mx-4" style={{ marginBottom: "2rem" }}>
                                    <I18n id="deposits.summary.checkInfo.label" component="h2" />
                                </div>
                            ) : null}

                            <Col
                                className={`col-12${!isDesktop ? " px-0" : " col-xl-4"}`}
                                lg={isDesktop ? 4 : 12}
                                md={isDesktop ? 9 : 12}
                                sm={12}>
                                {!isDesktop && checkInfoTitle}
                                <DepositSummaryData isDesktop={isDesktop} />
                                {credentials}
                                {continueButton}
                            </Col>
                        </Container>
                    </Form>
                </MainContainer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    summary: depositsSelectors.getSummary(state),
    userId: sessionSelectors.getUser(state).userId,
    loadingConfirm: depositsSelectors.getLoadingConfirm(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: () => ({ otp: "" }),
        validationSchema: () =>
            Yup.object().shape({
                otp: Yup.string().required(i18nUtils.get(`${FORM_ID}.otp.error.required`)),
            }),
        handleSubmit: ({ otp }, formikBag) => {
            const { dispatch, summary } = formikBag.props;

            dispatch(depositsActions.confirmDeposit({ ...summary, formikBag }, otp));
        },
    }),
    resizableRoute,
)(DepositSummary);
